"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileSize = exports.getFileName = exports.getFileMimeType = exports.getFileContents = exports.isWebFile = void 0;

function isWebFile(file) {
  return typeof file.arrayBuffer !== 'undefined';
}

exports.isWebFile = isWebFile;

function getFileContents(file) {
  return isWebFile(file) ? file : file.uri;
}

exports.getFileContents = getFileContents;

function getFileMimeType(file) {
  return file.type;
}

exports.getFileMimeType = getFileMimeType;

function getFileName(file) {
  return file.name;
}

exports.getFileName = getFileName;

function getFileSize(file) {
  return file.size;
}

exports.getFileSize = getFileSize;